import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle, XCircle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";

export function PaymentSuccess() {
    const [params] = useSearchParams();
    const sessionId = params.get("session_id");
    const [status, setStatus] = useState("checking");
    const { refresh } = useAuth();

    useEffect(() => {
        if (!sessionId) return;
        let attempts = 0;
        const poll = async () => {
            attempts += 1;
            try {
                const { data } = await api.get(`/payments/status/${sessionId}`);
                if (data.payment_status === "paid") {
                    setStatus("paid");
                    refresh();
                    return;
                }
                if (data.payment_status === "expired" || data.payment_status === "failed") {
                    setStatus("failed");
                    return;
                }
            } catch (err) { console.error("Payment status poll failed:", err); }
            if (attempts < 15) setTimeout(poll, 2000);
            else setStatus("timeout");
        };
        poll();
    }, [sessionId]);

    return (
        <div className="mx-auto max-w-xl px-6 py-24 text-center" data-testid="payment-success-page">
            {status === "checking" && <p className="text-muted-foreground">Verifying your payment…</p>}
            {status === "paid" && (
                <>
                    <CheckCircle weight="fill" className="mx-auto text-primary" size={64} />
                    <h1 className="mt-6 font-display text-4xl font-semibold">Payment received</h1>
                    <p className="mt-4 text-muted-foreground">Your CRMA Vault is now unlocked. Time to build your streak.</p>
                    <div className="mt-8 flex justify-center gap-3">
                        <Link to="/practice"><Button className="bg-primary text-primary-foreground hover:bg-primary/90" data-testid="success-practice">Start practicing</Button></Link>
                        <Link to="/dashboard"><Button variant="outline">Go to dashboard</Button></Link>
                    </div>
                </>
            )}
            {(status === "failed" || status === "timeout") && (
                <>
                    <XCircle weight="fill" className="mx-auto text-destructive" size={64} />
                    <h1 className="mt-6 font-display text-4xl font-semibold">Payment not confirmed</h1>
                    <p className="mt-4 text-muted-foreground">If you were charged, your access will unlock shortly. Otherwise, please try again.</p>
                    <div className="mt-8"><Link to="/pricing"><Button variant="outline">Back to pricing</Button></Link></div>
                </>
            )}
        </div>
    );
}

export function PaymentCancel() {
    return (
        <div className="mx-auto max-w-xl px-6 py-24 text-center" data-testid="payment-cancel-page">
            <XCircle weight="fill" className="mx-auto text-muted-foreground" size={64} />
            <h1 className="mt-6 font-display text-4xl font-semibold">Checkout cancelled</h1>
            <p className="mt-4 text-muted-foreground">No charges were made. You can revisit pricing anytime.</p>
            <div className="mt-8"><Link to="/pricing"><Button className="bg-primary text-primary-foreground hover:bg-primary/90">See plans</Button></Link></div>
        </div>
    );
}
